import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'
import { Left, Right, Up, Down, Close } from './style'

const DirectionLink = ({
  direction,
  text,
  link,
  isDepenednt,
  onCloseFunc,
  isFocused,
  description,
  setFocus,
}) => {
  const colseBtn = useRef(null)
  const backBtn = useRef(null)
  const navigate = useNavigate()
  useEffect(() => {
    if (colseBtn.current) {
      colseBtn.current.focus()
    }
    if (backBtn.current) {
      backBtn.current.focus()
    }
  }, [setFocus])
  switch (direction) {
    case 'left':
      return (
        <Left
          onClick={() => navigate(link)}
          isDepenednt={isDepenednt}
          autoFocus={isFocused}
          aria-label={description}
          ref={backBtn}
        >
          {text}
        </Left>
      )
    case 'right':
      return (
        <Right
          onClick={() => navigate(link)}
          isDepenednt={isDepenednt}
          autoFocus={isFocused}
          aria-label={description}
        >
          {text}
        </Right>
      )
    case 'up':
      return (
        <Up
          onClick={() => navigate(link)}
          isDepenednt={isDepenednt}
          autoFocus={isFocused}
          aria-label={description}
        >
          {text}
        </Up>
      )
    case 'down':
      return (
        <Down
          onClick={() => navigate(link)}
          isDepenednt={isDepenednt}
          autoFocus={isFocused}
          aria-label={description}
        >
          {text}
        </Down>
      )
    case 'cross':
      return (
        <Close
          onClick={onCloseFunc}
          isDepenednt={isDepenednt}
          autoFocus={isFocused}
          aria-label={description}
          ref={colseBtn}
        >
          {text}
        </Close>
      )
    default:
      return (
        <Down
          onClick={() => navigate(link)}
          isDepenednt={isDepenednt}
          autoFocus={isFocused}
          aria-label={description}
        >
          {text}
        </Down>
      )
  }
}

DirectionLink.propTypes = {
  direction: PropTypes.oneOf(['left', 'right', 'up', 'down', 'cross'])
    .isRequired,
  text: PropTypes.string,
  link: PropTypes.string,
  isDepenednt: PropTypes.bool,
  onCloseFunc: PropTypes.func,
  isFocused: PropTypes.bool,
  description: PropTypes.string,
}

export default DirectionLink
